import _styled, { default as _styled2 } from "styled-components";
const _excluded = ["value", "onChange", "styledMaxHeight", "styledMinHeight", "valueIsValid"];
var _class, _FeedbackForm;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { Component, Children, isValidElement, cloneElement, useEffect, useRef, useId } from "react";
import { withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import sendFeedback from "../../Models/sendFeedback";
import Box from "../../Styled/Box";
import Button, { RawButton } from "../../Styled/Button";
import Checkbox from "../../Styled/Checkbox";
import { GLYPHS, StyledIcon } from "../../Styled/Icon";
import Input, { StyledTextArea } from "../../Styled/Input";
import Spacing from "../../Styled/Spacing";
import Text from "../../Styled/Text";
import parseCustomMarkdownToReact, { parseCustomMarkdownToReactWithOptions } from "../Custom/parseCustomMarkdownToReact";
import { withViewState } from "../Context";
import { applyTranslationIfExists } from "../../Language/languageHelpers";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let FeedbackForm = observer(_class = (_FeedbackForm = class FeedbackForm extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      isSending: false,
      sendShareURL: true,
      name: "",
      email: "",
      comment: "",
      commentIsValid: false
    });
    _defineProperty(this, "escKeyListener", void 0);
    this.escKeyListener = e => {
      if (e.keyCode === 27) {
        this.onDismiss();
      }
    };
    this.onDismiss = this.onDismiss.bind(this);
    this.updateName = this.updateName.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updateComment = this.updateComment.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.changeSendShareUrl = this.changeSendShareUrl.bind(this);
  }
  getInitialState() {
    return {
      isSending: false,
      sendShareURL: true,
      name: "",
      email: "",
      comment: ""
    };
  }
  componentDidMount() {
    window.addEventListener("keydown", this.escKeyListener, true);
    this.setState({
      commentIsValid: this.props.viewState.terria.configParameters.feedbackMinLength === 0
    });
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.escKeyListener, true);
  }
  resetState() {
    this.setState(this.getInitialState());
  }
  onDismiss() {
    runInAction(() => {
      this.props.viewState.feedbackFormIsVisible = false;
    });
    this.resetState();
  }
  updateName(e) {
    this.setState({
      name: e.target.value
    });
  }
  updateEmail(e) {
    this.setState({
      email: e.target.value
    });
  }
  updateComment(e) {
    this.setState({
      comment: e.target.value
    });
    if (this.state.comment.replace(/\s+/g, " ").length >= this.props.viewState.terria.configParameters.feedbackMinLength) {
      this.setState({
        commentIsValid: true
      });
    } else {
      this.setState({
        commentIsValid: false
      });
    }
  }
  changeSendShareUrl(_e) {
    this.setState(prevState => ({
      sendShareURL: !prevState.sendShareURL
    }));
  }
  onSubmit(e) {
    e.preventDefault();
    if (this.state.comment.length >= this.props.viewState.terria.configParameters.feedbackMinLength) {
      this.setState({
        isSending: true
      });
      sendFeedback({
        terria: this.props.viewState.terria,
        name: this.state.name,
        email: this.state.email,
        sendShareURL: this.state.sendShareURL,
        comment: this.state.comment
      }).then(succeeded => {
        if (succeeded) {
          this.setState({
            isSending: false,
            comment: ""
          });
          runInAction(() => {
            this.props.viewState.feedbackFormIsVisible = false;
          });
        } else {
          this.setState({
            isSending: false
          });
        }
      });
    }
  }
  render() {
    const {
      t,
      i18n,
      viewState,
      theme
    } = this.props;
    const preamble = parseCustomMarkdownToReact(applyTranslationIfExists(viewState.terria.configParameters.feedbackPreamble || "translate#feedback.feedbackPreamble", i18n));
    const postamble = viewState.terria.configParameters.feedbackPostamble ? parseCustomMarkdownToReact(applyTranslationIfExists(viewState.terria.configParameters.feedbackPostamble, i18n)) : undefined;
    return /*#__PURE__*/_jsxs(FormWrapper, {
      children: [/*#__PURE__*/_jsxs(Box, {
        backgroundColor: theme.darkLighter,
        paddedRatio: 2,
        children: [/*#__PURE__*/_jsx(_StyledText, {
          textLight: true,
          textAlignCenter: true,
          semiBold: true,
          as: "h4",
          fullWidth: true,
          children: t("feedback.title")
        }), /*#__PURE__*/_jsx(RawButton, {
          onClick: this.onDismiss,
          title: t("feedback.close"),
          children: /*#__PURE__*/_jsx(StyledIcon, {
            styledWidth: "15px",
            light: true,
            glyph: GLYPHS.close
          })
        })]
      }), /*#__PURE__*/_jsxs(Form, {
        paddedRatio: 2,
        onSubmit: this.onSubmit.bind(this),
        column: true,
        children: [/*#__PURE__*/_jsx(Text, {
          textDarker: true,
          children: preamble
        }), /*#__PURE__*/_jsx(StyledLabel, {
          viewState: viewState,
          textProps: {
            textDarker: true
          },
          label: t("feedback.yourName"),
          spacingBottom: true,
          children: /*#__PURE__*/_jsx(Input, {
            styledHeight: "34px",
            white: true,
            fieldBorder: theme.greyLighter,
            border: true,
            id: "name",
            type: "text",
            name: "name",
            value: this.state.name,
            onChange: this.updateName,
            autoComplete: "off"
          })
        }), /*#__PURE__*/_jsx(StyledLabel, {
          viewState: viewState,
          textProps: {
            textDarker: true
          },
          label: t("feedback.email"),
          spacingBottom: true,
          children: /*#__PURE__*/_jsx(Input, {
            styledHeight: "34px",
            white: true,
            fieldBorder: theme.greyLighter,
            border: true,
            id: "email",
            type: "text",
            name: "email",
            value: this.state.email,
            onChange: this.updateEmail,
            autoComplete: "off"
          })
        }), /*#__PURE__*/_jsxs(StyledLabel, {
          viewState: viewState,
          textProps: {
            textDarker: true
          },
          label: t("feedback.commentQuestion"),
          spacingBottom: true,
          children: [/*#__PURE__*/_jsx(TextArea, {
            lineHeight: "22px",
            styledMinHeight: "56px",
            styledMaxHeight: "120px",
            white: true,
            fieldBorder: theme.greyLighter,
            border: true,
            name: "comment",
            value: this.state.comment,
            valueIsValid: this.state.commentIsValid,
            onChange: this.updateComment,
            autoComplete: "off"
          }), !this.state.commentIsValid && /*#__PURE__*/_jsx(WarningText, {
            children: t("feedback.minLength", {
              minLength: viewState.terria.configParameters.feedbackMinLength
            })
          })]
        }), /*#__PURE__*/_jsx(Checkbox, {
          isChecked: this.state.sendShareURL,
          value: "sendShareUrl",
          onChange: this.changeSendShareUrl,
          children: /*#__PURE__*/_jsx(Text, {
            children: t("feedback.shareWithDevelopers", {
              appName: this.props.viewState.terria.appName
            })
          })
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 2
        }), postamble ? /*#__PURE__*/_jsx(Text, {
          textDarker: true,
          children: postamble
        }) : null, /*#__PURE__*/_jsxs(Box, {
          right: true,
          children: [/*#__PURE__*/_jsx(Button, {
            type: "button",
            denyButton: true,
            shortMinHeight: true,
            styledMinWidth: "80px",
            onClick: this.onDismiss,
            children: t("feedback.cancel")
          }), /*#__PURE__*/_jsx(Spacing, {
            right: 1
          }), /*#__PURE__*/_jsx(Button, {
            type: "submit",
            primary: true,
            shortMinHeight: true,
            styledMinWidth: "80px",
            disabled: this.state.comment.length < viewState.terria.configParameters.feedbackMinLength || this.state.isSending,
            children: this.state.isSending ? t("feedback.sending") : t("feedback.send")
          })]
        })]
      })]
    });
  }
}, _defineProperty(_FeedbackForm, "displayName", "FeedbackForm"), _FeedbackForm)) || _class;
const WarningText = styled(Text).withConfig({
  displayName: "FeedbackForm__WarningText",
  componentId: "sc-z0uugm-0"
})(["color:red;"]);
const TextArea = props => {
  const {
      value,
      onChange,
      styledMaxHeight,
      styledMinHeight,
      valueIsValid
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const textAreaRef = useRef(null);
  useEffect(() => {
    textAreaRef.current.style.setProperty("height", "".concat(textAreaRef.current.scrollHeight + 2, "px"));
  }, [value]);
  return /*#__PURE__*/_jsx(StyledTextArea, _objectSpread(_objectSpread({}, rest), {}, {
    ref: textAreaRef,
    rows: 1,
    styledHeight: styledMinHeight,
    styledMinHeight: styledMinHeight,
    styledMaxHeight: styledMaxHeight,
    onChange: event => {
      textAreaRef.current.style.setProperty("height", "auto");
      if (props.onChange) {
        props.onChange(event);
      }
    },
    invalidValue: !valueIsValid
  }));
};
const StyledLabel = props => {
  const {
    viewState,
    label,
    textProps
  } = props;
  const id = useId();
  const childrenWithId = Children.map(props.children, child => {
    // checking isValidElement is the safe way and avoids a typescript error too
    if (/*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement(child, {
        id: id
      });
    }
    return child;
  });
  return /*#__PURE__*/_jsxs(Box, {
    column: true,
    children: [label && /*#__PURE__*/_jsx(_StyledText2, _objectSpread(_objectSpread({
      as: "label",
      htmlFor: id
    }, textProps), {}, {
      $_css: "p {margin: 0;}",
      children: parseCustomMarkdownToReactWithOptions("".concat(label, ":"), {
        injectTermsAsTooltips: true,
        tooltipTerms: viewState.terria.configParameters.helpContentTerms
      })
    })), childrenWithId, props.spacingBottom && /*#__PURE__*/_jsx(Spacing, {
      bottom: 2
    })]
  });
};
const Form = styled(Box).attrs({
  overflowY: "auto",
  scroll: true,
  as: "form"
}).withConfig({
  displayName: "FeedbackForm__Form",
  componentId: "sc-z0uugm-1"
})([""]);
const FormWrapper = styled(Box).attrs(props => ({
  column: true,
  position: "absolute",
  styledMaxHeight: "60vh",
  styledMaxWidth: "400px",
  styledWidth: "350px",
  backgroundColor: props.theme.textLight
})).withConfig({
  displayName: "FeedbackForm__FormWrapper",
  componentId: "sc-z0uugm-2"
})(["z-index:", ";border-radius:5px;@media (min-width:", "px){bottom:75px;right:20px;}@media (max-width:", "px){right:0;top:50px;left:0;max-height:calc(100vh - 50px);min-width:100%;}"], props => props.theme.notificationWindowZIndex, props => props.theme.sm, props => props.theme.sm);
export default withTranslation()(withViewState(withTheme(FeedbackForm)));
var _StyledText = styled(Text).withConfig({
  displayName: "FeedbackForm___StyledText",
  componentId: "sc-z0uugm-3"
})(["margin:0;"]);
var _StyledText2 = styled(Text).withConfig({
  displayName: "FeedbackForm___StyledText2",
  componentId: "sc-z0uugm-4"
})(["", ""], p => p.$_css);